import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import globals from "./globals";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'prokuraturaUz'
});

export default new Vuex.Store({
  state: {
    accessToken: "",
    refreshToken: "",
    permissions: {
      roles: {},
      static: [],
      dynamic: {}
    },
    login: "",
    locale: "uz-CYR",
    profile: {
      structure: {
        id: null,
        name: {}
      },
      level: {
        id: null,
        name: {}
      },
      branch: {
        id: null,
        name: {}
      },
      department: {
        id: null,
        name: {}
      },
      position: {
        id: null,
        name: {}
      },
      employee: {},
      login: "m@test.uz"
      // photoUrl: "/api/v1/static/AB/9062738.jpg"
    },
    uiState: {
      sidebarCollapsed: false
    },
    oneId:{
      accessToken: null,
      info: {}
    }
  },
  mutations: {
    setAppSettings(state, data) {
      const { active } = data;
      state.app_settings = {
        active: globals.getBool(active)
      };
    },
    setUserPermissions(state, data) {
      Vue.set(state.permissions, "static", data);
    },
    clearUserPermissions(state) {
      Vue.set(state.permissions, "static", []);
    },
    setProfile(state, data) {
      Vue.set(state, "profile", data);
    },
    clearProfile(state) {
      Vue.set(state, "profile", {});
    },
    setUiState(state, uiState) {
      state.uiState = uiState;
    },
    setLocale(state, locale) {
      Vue.set(state, 'locale', locale );
      console.log('state.locale', state.locale);
    },
    setOneIdToken(state, token){
      state.oneId.accessToken = token;
    },
    setOneIdInfo(state, info){
      state.oneId.info = info;
    },
    clearOneId(state){
      state.oneId = {
        accessToken: null,
        info: {}
      };
    }
  },
  actions: {},
  plugins: [vuexPersist.plugin]
});
